const angular = require('angular');

const Searchable = {
    name: 'searchable',
    selectedValue: true,
    type: 'checkbox'
};

const Reportable = {
    name: 'reportable',
    selectedValue: true,
    type: 'checkbox'
};

const Customizable = {
    name: 'customizable.column',
    selectedValue: true,
    type: 'checkbox'
};

const FieldName = {
    name: 'field.name',
    selectedValue: '',
    prevSelectedValue: '',
    type: 'textbox',
    onChangeFunction: 'restrictChar',
    addOnButton: 'fa fa-info'
};

function getFieldName(selectedValue) {
    const fieldName = angular.copy(FieldName);
    fieldName.selectedValue = selectedValue;
    fieldName.prevSelectedValue = selectedValue;
    return fieldName;
}

const DataFieldName = {
    name: 'Data-Field-Name',
    selectedValue: '',
    prevSelectedValue: '',
    type: 'textbox',
    onChangeFunction: 'restrictCharInDataFieldName',
    addOnButton: 'fa fa-info'
};
function getDataFieldName(selectedValue) {
    const dataFieldName = angular.copy(DataFieldName);
    dataFieldName.selectedValue = selectedValue;
    dataFieldName.prevSelectedValue = selectedValue
    return dataFieldName;
}

const marginObject = {
    'margin-top': {
        name: 'top',
        type: 'number',
        title: 'margin.size',
        selectedValue: 5,
        min: 5,
        max: 999,
        default: 0
    },
    'margin-bottom': {
        name: 'bottom',
        type: 'number',
        title: 'margin.size',
        selectedValue: 5,
        min: 5,
        max: 999,
        default: 0
    },
    'margin-left': {
        name: 'left',
        type: 'number',
        title: 'margin.size',
        selectedValue: 5,
        min: 5,
        max: 999,
        default: 0
    },
    'margin-right': {
        name: 'right',
        type: 'number',
        title: 'margin.size',
        selectedValue: 5,
        min: 5,
        max: 999,
        default: 0
    },
    'Name': {
        selectedValue: 'padding',
        hidden: true
    }
}

const styleObject = {
    'font-style-group': {
        type: 'style-group',
        members: {
            'font-family': {
                type: 'dd',
                title: 'font.family',
                selectedValue: 'Helvetica',
                options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
            },
            'font-size': {
                type: 'number',
                title: 'font.size',
                selectedValue: 14,
                min: '1',
                max: '99',
                default: 16
            },
            'background-color': {
                type: 'color-picker',
                title: 'background.color',
                selectedValue: '#ffffff',
                icon: 'fa fa-paint-brush'
            }
        }
    },
    'style-group': {
        type: 'style-group',
        members: {
            'bold': {
                type: 'btn-toggle',
                title: 'bold',
                icon: 'fa fa-bold',
                selectedValue: false
            }, 'italic': {
                type: 'btn-toggle',
                title: 'italic',
                icon: 'fa fa-italic',
                selectedValue: false
            }, 'underline': {
                type: 'btn-toggle',
                title: 'underline',
                icon: 'fa fa-underline',
                selectedValue: false
            },
            'alignment': {
                type: 'radio-btn',
                selectedValue: 'left',
                options: [{
                    value: 'left',
                    title: 'align.left',
                    icon: 'fa fa-align-left',
                    name: 'alignment'
                }, {
                    value: 'center',
                    title: 'align.center',
                    icon: 'fa fa-align-justify',
                    name: 'alignment'
                }, {
                    value: 'right',
                    title: 'align.right',
                    icon: 'fa fa-align-right',
                    name: 'alignment'
                }]
            },
            'font-color': {
                type: 'color-picker',
                title: 'font.color',
                selectedValue: '#000000',
                icon: 'fa fa-font'
            }
        }
    },
    'Name': {
        selectedValue: 'style',
        hidden: true
    }
};

const eventsObject = {
    Name: {
        selectedValue: 'Events',
        hideSection: false,
        hidden: true
    },
    load: {
        name: 'onLoad',
        type: 'event',
        selectedValue: '',
        xmlValue: '',
        systemFields: [],
        onClickFunction: 'openCodeEditorDialog'
    },
    change: {
        name: 'onChange',
        type: 'event',
        selectedValue: '',
        xmlValue: '',
        systemFields: [],
        onClickFunction: 'openCodeEditorDialog'
    },
    focus: {
        name: 'onFocus',
        type: 'event',
        selectedValue: '',
        xmlValue: '',
        systemFields: [],
        onClickFunction: 'openCodeEditorDialog'
    },
    blur: {
        name: 'onBlur',
        type: 'event',
        selectedValue: '',
        xmlValue: '',
        systemFields: [],
        onClickFunction: 'openCodeEditorDialog'
    },
    enter: {
        name: 'onEnter',
        type: 'event',
        selectedValue: '',
        xmlValue: '',
        systemFields: [],
        onClickFunction: 'openCodeEditorDialog'
    }
}

let labelStyleObject = angular.copy(styleObject);
labelStyleObject.Name.selectedValue = 'label.style';

let controlStyleObject = angular.copy(styleObject);
let alignmentRadioOptions = controlStyleObject['style-group'].members.alignment.options;

controlStyleObject.Name.selectedValue = 'control.style';

delete controlStyleObject['font-style-group'].members['background-color'];

for (let i = 0; i < alignmentRadioOptions.length; i++) {
    const element = alignmentRadioOptions[i];
    element.name = 'controlAlignment';
}

let elementEventsObject = angular.copy(eventsObject);

const InsertButtonStyleObj = angular.copy(controlStyleObject);
InsertButtonStyleObj['Name'].selectedValue = 'insert.button.style';
InsertButtonStyleObj['style-group'].members['font-color']['selectedValue'] = '#337ab7';
InsertButtonStyleObj['font-style-group'].members['font-size']['selectedValue'] = 12;

export {
    Searchable,
    Reportable,
    Customizable,
    marginObject,
    styleObject,
    getFieldName,
    getDataFieldName,
    labelStyleObject,
    controlStyleObject,
    elementEventsObject,
    InsertButtonStyleObj
};




// WEBPACK FOOTER //
// ./client/app/localStorage/Props.ts